import { render, staticRenderFns } from "./AboutTheDeveloper.vue?vue&type=template&id=253a97e8&"
import script from "./AboutTheDeveloper.vue?vue&type=script&lang=ts&"
export * from "./AboutTheDeveloper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports